module.exports = __webpack_public_path__ + "img/wild_3.26cac617.png";